import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  EnumCellProps,
  isEnumControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsEnumCellProps } from "@jsonforms/react";
import { capitalCase } from "change-case";

export const EnumCell = (props: EnumCellProps) => {
  const { data, id, enabled, path, handleChange, options } = props;

  return (
    <Select
      disabled={!enabled}
      value={data || ""}
      onValueChange={(value) =>
        handleChange(path, value === "" ? undefined : value)
      }
    >
      <SelectTrigger id={id}>
        <SelectValue placeholder="Select an option" />
      </SelectTrigger>
      <SelectContent>
        {options?.map((optionValue) => (
          <SelectItem key={optionValue.value} value={optionValue.value}>
            {capitalCase(optionValue.label)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const enumCellTester: RankedTester = rankWith(3, isEnumControl);

export default withJsonFormsEnumCellProps(EnumCell);
